var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "products_decor",
    viewBox: "0 0 451 940"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.508 0C248.903 30.3953 450.19 473.082 450.19 473.082L149.764 939.904H0L185.795 481.761L72.0636 0H218.508Z",
    fill: "currentColor"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "cup_symbol",
    viewBox: "0 0 217 309"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.6192 31.0991L18.6875 29.0629L24.4639 8.84539C25.206 6.25231 26.802 3.9858 28.9932 2.41315C31.1844 0.840503 33.8425 0.0538719 36.5367 0.180738L192.096 10.4917C194.797 10.6505 196.89 13.1777 197.41 16.918L198.854 28.1098L191.634 29.0773L190.19 17.8855V17.5967L36.1034 7.40128C35.0382 7.38305 33.9977 7.72341 33.1491 8.36769C32.3005 9.01197 31.6932 9.92277 31.4245 10.9538L25.6192 31.0991Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.046 59.4762H4.40099C3.77387 59.4756 3.15565 59.3277 2.59625 59.0442C2.03684 58.7607 1.55192 58.3497 1.18063 57.8443C0.808722 57.3268 0.563931 56.729 0.466084 56.0992C0.368237 55.4695 0.420085 54.8256 0.617429 54.2196L7.96794 31.8648C8.4961 30.2593 9.51149 28.8583 10.8729 27.8566C12.2343 26.855 13.874 26.3026 15.5639 26.2761H201.854C203.544 26.3026 205.184 26.855 206.545 27.8566C207.906 28.8583 208.922 30.2593 209.45 31.8648L216.8 54.2052C216.998 54.8111 217.05 55.4551 216.952 56.0848C216.854 56.7145 216.609 57.3124 216.237 57.8299C215.874 58.3374 215.395 58.7513 214.84 59.0375C214.285 59.3237 213.67 59.4741 213.046 59.4762ZM8.86329 52.2556H208.583L202.59 34.1176C202.541 33.9538 202.445 33.8078 202.315 33.6976C202.184 33.5873 202.024 33.5175 201.854 33.4967H15.5639C15.3941 33.5175 15.2341 33.5873 15.1033 33.6976C14.9725 33.8078 14.8767 33.9538 14.8274 34.1176L8.86329 52.2556Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.378 308.571H48.0733C46.1877 308.567 44.3682 307.876 42.9563 306.626C41.5444 305.377 40.6372 303.655 40.4051 301.783L10.3965 56.5016L17.617 55.6352L47.5389 300.902C47.5532 301.026 47.6127 301.14 47.7059 301.223C47.7992 301.306 47.9198 301.351 48.0444 301.35H169.349C169.474 301.351 169.595 301.306 169.688 301.223C169.781 301.14 169.841 301.026 169.855 300.902L199.878 55.5774L207.098 56.4439L177.075 301.783C176.843 303.66 175.931 305.386 174.513 306.636C173.095 307.886 171.269 308.574 169.378 308.571Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.894 119.045H21.6914L36.6668 241.303H180.904L195.894 119.045Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.785 227.108C134.706 227.108 155.719 206.095 155.719 180.175C155.719 154.254 134.706 133.241 108.785 133.241C82.8644 133.241 61.8516 154.254 61.8516 180.175C61.8516 206.095 82.8644 227.108 108.785 227.108Z",
    fill: "var(--colLabel, white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.473 164.479C134.815 163.84 133.761 163.84 133.103 164.479L102.371 194.915L86.709 179.404C86.0352 178.903 85.0921 178.969 84.4962 179.559C83.9003 180.15 83.833 181.084 84.3385 181.752L101.271 198.521C101.929 199.16 102.982 199.16 103.641 198.521L135.473 166.911C135.81 166.595 136 166.155 136 165.696C136 165.236 135.81 164.796 135.473 164.48V164.479Z",
    fill: "var(--colMark, white)"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "ruble_symbol",
    viewBox: "0 0 94 126"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 42.2029V78.9817H1H0.5V79.4817V83.4054V83.9054H1H9.58203V103.703H1H0.5V104.203V108.126V108.626H1H9.58203V125V125.5H10.082H14.0301H14.5301V125V108.626H35.747H36.247V108.126V104.203V103.703H35.747H14.5301L14.5314 83.9068H51.5412H52.5286H53.516H53.5294L53.5429 83.9061C75.7145 82.7138 93.5 64.4507 93.5 42.2039V41.9352L93.4976 41.9336C93.3518 19.0185 74.6234 0.5 51.5402 0.5C28.3659 0.5 9.58203 19.1645 9.58203 42.2029ZM88.55 42.2029C88.55 62.1329 72.3904 78.397 52.52 78.9817H14.5304V42.2029C14.5304 21.8801 31.085 5.42409 51.5402 5.42409C71.9964 5.42409 88.55 21.8812 88.55 42.2029Z",
    fill: "currentColor",
    stroke: "currentColor"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "card_symbol",
    viewBox: "0 0 441 283",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.9602 4H415.367C427.315 4 436.999 15.9478 436.999 25.6321V257.221C436.999 269.169 427.315 278.853 415.367 278.853H25.9602C14.0125 278.853 4.32812 266.905 4.32812 257.221V25.6321C4.32812 13.6843 14.0125 4 25.9602 4Z",
    stroke: "currentColor",
    strokeWidth: 7.46667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.875 70.4697C358.814 75.559 360.361 81.3309 360.361 87.2088C360.361 93.0867 358.814 98.8586 355.875 103.948",
    stroke: "currentColor",
    strokeWidth: 7.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.922 77.4465C345.635 80.4118 346.536 83.7809 346.536 87.206C346.536 90.6354 345.635 94.0007 343.922 96.9694",
    stroke: "currentColor",
    strokeWidth: 7.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.609 63.7632C375.974 78.2729 375.974 96.1397 367.609 110.653",
    stroke: "currentColor",
    strokeWidth: 7.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.699 56.1914C390.829 75.6131 390.829 98.7541 380.699 118.177",
    stroke: "currentColor",
    strokeWidth: 7.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6015 56.1914H110.117C116.093 56.1914 120.933 62.1672 120.933 67.0077V108.978C120.933 114.954 116.089 119.795 110.117 119.795H59.6015C53.6257 119.795 48.7852 113.819 48.7852 108.978V67.0077C48.7852 61.0319 53.6292 56.1914 59.6015 56.1914Z",
    stroke: "currentColor",
    strokeWidth: 7.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "success_symbol",
    viewBox: "0 0 52 35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.4732 0.479433C50.8148 -0.159811 49.7613 -0.159811 49.1028 0.479433L18.3711 30.9152L2.70896 15.4039C2.03515 14.9032 1.0921 14.9693 0.496151 15.5594C-0.0997058 16.1496 -0.167026 17.0842 0.338471 17.7515L17.2705 34.5206C17.929 35.1598 18.9825 35.1598 19.641 34.5206L51.4732 2.91096C51.8099 2.59455 52 2.15532 52 1.69562C52 1.23592 51.8099 0.796111 51.4732 0.4797V0.479433Z",
    fill: "currentColor"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning_symbol",
    viewBox: "0 0 355 334",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.514 329.827H72.45C12.2893 329.827 -12.8499 286.885 16.2769 234.421L70.3695 137.11L121.341 45.6861C152.202 -9.89537 202.827 -9.89537 233.688 45.6861L284.659 137.283L338.752 234.594C367.879 287.059 342.566 330 282.579 330H177.514V329.827Z",
    stroke: "currentColor",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.018 114.737V201.67",
    stroke: "currentColor",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.982 253.416H178.017",
    stroke: "currentColor",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.fafeda3cd0ef80e8eb861027246ceb03.svg";
export { ForwardRef as ReactComponent };